<template>
  <div class="myfinbiz-intro">
    <header class="hero">
      <h1 class="hero-title">소상공인을 위한 종합 금융 패키지</h1>
      <p class="hero-subtitle">펀다의 다양한 소상공인 금융 패키지를 통해<br>
        현금 흐름을 개선하고 매출을 증진하세요</p>
      <button @click="$emit('start-survey')" class="cta-button">맞춤 서비스 찾기</button>
    </header>

    <section class="services">
      <h2 class="section-title">펀다 금융패키지 구성 서비스</h2>
      <div class="service-grid">
        <div class="service-card">
          <i class="fas fa-calendar-check"></i>
          <h3>365 오전 선정산</h3>
          <p>매일 오전 11시, 전날 카드+배달 매출을 선정산 받아 유동성을 확보하세요.</p>
        </div>
        <div class="service-card">
          <i class="fas fa-hand-holding-usd"></i>
          <h3>5일매출 당겨받기</h3>
          <p>향후 5일간의 예상 매출을 미리 받아 긴급 자금을 확보할 수 있습니다.</p>
        </div>
        <div class="service-card">
          <i class="fas fa-users"></i>
          <h3>우리동네 크라우드펀딩</h3>
          <p>지역 주민들과 함께 성장하는 크라우드펀딩으로 자금을 모집하세요.</p>
        </div>
        <div class="service-card">
          <i class="fas fa-piggy-bank"></i>
          <h3>제휴 저축은행 대출 연결</h3>
          <p>펀다와 제휴된 저축은행을 통해 유리한 조건의 소상공인 전용 대출을 받아보세요.</p>
        </div>
        <div class="service-card">
          <i class="fas fa-utensils"></i>
          <h3>식자재 외상결제 (예정)</h3>
          <p>식자재 구매 시 외상으로 결제하고, 나중에 편리하게 상환하세요.</p>
        </div>
        <div class="service-card">
          <i class="fas fa-user-friends"></i>
          <h3>알바비 대신결제 (예정)</h3>
          <p>알바생들의 급여를 먼저 지급하고, 후에 편리하게 상환할 수 있습니다.</p>
        </div>
      </div>
    </section>

    <section class="partners">
      <h2 class="section-title">펀다 파트너 서비스</h2>
      <p class="partner-info-pre">펀다 종합 금융 서비스는 각 지역의 "펀다 파트너 서비스"를 통해서만 제공됩니다.</p>
      <p class="partner-info">2024년 7월 30일 현재, 펀다와 함께하는 파트너 서비스는 다음과 같습니다.</p>
      <div class="partner-logos">
        <img :src="require('@/assets/logo/ssonda.png')" alt="바로쏜다" class="partner-logo">
        <img :src="require('@/assets/logo/jeonghoonkingpay.png')" alt="정훈킹페이" class="partner-logo">
        <img :src="require('@/assets/logo/jgpay.png')" alt="정글페이" class="partner-logo">
        <img :src="require('@/assets/logo/365pay.png')" alt="365입금" class="partner-logo">
        <img :src="require('@/assets/logo/pay-1.png')" alt="페이원" class="partner-logo">
        <img :src="require('@/assets/logo/miridream.png')" alt="미리드림" class="partner-logo">
      </div>
    </section>

    <section class="recommendation">
      <h2 class="section-title">맞춤 서비스 찾기</h2>
      <p class="recommendation-info">간단한 정보를 입력하시면 사장님께 적합한 파트너 서비스를 추천해 드립니다.</p>
      <button @click="$emit('start-survey')" class="cta-button">맞춤 서비스 찾기</button>
    </section>

  </div>
</template>

<script>
export default {
  name: 'MyfinbizIntro'
}
</script>

<style scoped>
.myfinbiz-intro {
  font-family: 'Arial', sans-serif;
  color: #333;
  line-height: 1.6;
}

.hero {
  background: linear-gradient(135deg, #3498db, #8e44ad);
  color: white;
  text-align: center;
  padding: 10vh 0;
  width: 100vw;
  box-sizing: border-box;
  margin-left: 50%;
  transform: translateX(-50%);
  position: relative;
}

.hero-title {
  font-size: clamp(2em, 5vw, 3em);
  margin-bottom: 20px;
}

.hero-subtitle {
  font-size: clamp(1em, 3vw, 1.5em);
  margin-bottom: 40px;
  line-height: 1.5;
}

.cta-button {
  background-color: #e74c3c;
  color: white;
  padding: 15px 30px;
  font-size: clamp(1em, 2vw, 1.2em);
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.cta-button:hover {
  background-color: #c0392b;
}

.section-title {
  text-align: center;
  font-size: clamp(1.8em, 4vw, 2.5em);
  margin: 60px 0 40px;
}

.services, .partners, .recommendation {
  padding: 60px 5vw;
}

.service-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 30px;
  max-width: 1200px;
  margin: 0 auto;
}

.service-card {
  text-align: center;
  padding: 30px;
  background-color: #ffffff;
  border-radius: 15px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.service-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.2);
}

.service-card i {
  font-size: clamp(2.5em, 5vw, 3.5em);
  color: #3498db;
  margin-bottom: 20px;
}

.service-card h3 {
  font-size: clamp(1.2em, 3vw, 1.5em);
  margin-bottom: 15px;
  color: #2c3e50;
}

.service-card p {
  font-size: clamp(0.9em, 2vw, 1em);
  color: #7f8c8d;
}

.partner-info-pre, .partner-info, .recommendation-info {
  text-align: center;
  margin-bottom: 20px;
}

.partner-logos {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 30px;
}

.partner-logo {
  width: 150px;
  height: auto;
  object-fit: contain;
  transition: filter 0.3s ease;
}

.partner-logo:hover {
  filter: grayscale(0%);
}

.recommendation {
  background-color: #f9f9f9;
  text-align: center;
}

.recommendation-info {
  font-size: clamp(1em, 2vw, 1.2em);
  margin-bottom: 30px;
}

@media (max-width: 768px) {
  .service-grid {
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  }

  .partner-logos {
    gap: 15px;
  }

  .partner-logo {
    width: 100px;
  }
}
</style>
